var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99941 0.833496C10.1587 0.833484 10.304 0.924242 10.3739 1.06734L13.1108 6.67259L19.2272 7.57068C19.3836 7.59365 19.5135 7.70314 19.5627 7.85339C19.6118 8.00363 19.5717 8.16875 19.4591 8.27971L15.0308 12.6436L16.0758 18.6791C16.1027 18.8345 16.0395 18.9918 15.9126 19.0854C15.7857 19.1791 15.6167 19.193 15.4762 19.1215L9.99946 16.3338L4.52379 19.1215C4.38322 19.193 4.2143 19.1791 4.08737 19.0854C3.96045 18.9918 3.89728 18.8345 3.92419 18.6791L4.96915 12.6436L0.540843 8.27971C0.428248 8.16875 0.38814 8.00363 0.437287 7.85339C0.486433 7.70314 0.61637 7.59365 0.772773 7.57068L6.88908 6.6726L9.625 1.0674C9.69485 0.924287 9.84017 0.833508 9.99941 0.833496ZM9.99951 2.19992L7.54154 7.23568C7.4812 7.3593 7.36373 7.44517 7.22763 7.46516L1.72188 8.27359L5.70936 12.2031C5.80664 12.2989 5.85076 12.4364 5.82746 12.5709L4.88727 18.0013L9.81041 15.4949C9.92917 15.4345 10.0697 15.4344 10.1885 15.4949L15.1127 18.0014L14.1725 12.5709C14.1492 12.4364 14.1933 12.2989 14.2906 12.2031L18.2781 8.27359L12.7723 7.46516C12.6362 7.44518 12.5188 7.35933 12.4584 7.23573L9.99951 2.19992Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.524bf661bd73558d4caeff066f143e26.svg";
export { ForwardRef as ReactComponent };